export default{
    methods:{
        convertHoursMinsSecsToSeconds(time) {
            if (time == null)
                return null;
            var multiplier = [1, 60, 60 * 60, 24 * 60 * 60];
            var timeArray = time.split(":");
            var seconds = 0;
            for (var i = timeArray.length - 1; i >= 0; i--) {
                seconds +=
                    parseInt(timeArray[i]) * multiplier[timeArray.length - 1 - i];
            }
            return seconds;

        },
        convertSecondsToHourMinsSecs(time) {
            if (time == null)
                return null;
            var multiplier = [60, 60 * 60];
            var outputString = "";
            for (var i = multiplier.length - 1; i >= 0; i--) {
                var divided = parseInt(time / multiplier[i]);
                if (divided != 0 || i < 1 || outputString != "") {
                    outputString += divided.toString().padStart(2, "0");
                }
                time = time % multiplier[i]
                if (outputString != "")
                    outputString += ":";
            }
            outputString += parseInt(time).toString().padStart(2, "0");
            return outputString;
        }
    }
}